const MOBILE_VIEW_MAX_WIDTH = 768
const sections = document.querySelectorAll('.collection-list-slider')
const titleItems = Array.from(document.querySelectorAll('.js-collection-list-title-item'))

sections.forEach((section) => {
  let isTransitioning = false
  const cards = section.querySelectorAll('.collection-list-slider__card')
  let isMobileView = window.innerWidth <= MOBILE_VIEW_MAX_WIDTH

  const resizeObserver = new ResizeObserver(() => {
    const wasDesktopView = !isMobileView
    isMobileView = window.innerWidth <= MOBILE_VIEW_MAX_WIDTH

    // If transitioning from desktop to mobile, reset to first card
    if (wasDesktopView && isMobileView) {
      const selectedCard = section.querySelector('.collection-list-slider__card')

      swapCards(selectedCard)
    }
  })
  resizeObserver.observe(section)

  function swapCards(clickedCard, selectFirst = false) {
    const clickedProductId = parseInt(clickedCard.dataset.blockIndex)
    const selectedCard = section.querySelector('[data-selected]')
    const selectedCardId = parseInt(selectedCard.dataset.blockIndex)

    if ((clickedProductId === selectedCardId || isTransitioning) && !selectFirst) return
    section.style.height = section.offsetHeight + 'px'

    section.dataset.selectedBlockIndex = clickedCard.dataset.blockIndex
    selectedCard.removeAttribute('data-selected')
    clickedCard.setAttribute('data-selected', '')

    if (isMobileView) {
      isTransitioning = true

      const selectedCardRect = selectedCard.getBoundingClientRect()
      const clickedCardRect = clickedCard.getBoundingClientRect()
      const scrollOffset = clickedCardRect.right - selectedCardRect.left - selectedCardRect.width

      const inner = section.querySelector('.collection-list-slider__inner')
      inner.style.transform = `translateX(-${scrollOffset}px)`

      // Handle infinite carousel rearrangement
      const transitionHandler = () => {
        try {
          const selectedCard = section.querySelector('[data-selected]')
          const clickedCardIndex = parseInt(selectedCard.dataset.blockIndex)
          const allCards = Array.from(inner.children)
          const cardsToMove = allCards.slice(0, clickedCardIndex)

          if (cardsToMove.length > 0) {
            // Disable transitions temporarily
            inner.style.transition = 'none'

            // Move cards that were before selected card to the end
            cardsToMove.forEach((card) => {
              inner.appendChild(card)
            })

            inner.style.transform = 'translateX(0)'

            // Update block indices
            Array.from(inner.children).forEach((card, index) => {
              card.dataset.blockIndex = index
            })

            // Update section's selected block index to 0 since selected card is now first
            section.dataset.selectedBlockIndex = '0'

            // Force reflow to apply position changes, then re-enable transitions
            void inner.offsetHeight
            inner.style.transition = ''
          }
        } finally {
          isTransitioning = false
        }
      }

      section.addEventListener('transitionend', transitionHandler, { once: true })
    }

    section.addEventListener(
      'transitionend',
      () => {
        section.style.height = ''
      },
      { once: true }
    )
  }

  cards.forEach((card, index) => {
    card.addEventListener('click', (e) => {
      titleItems.forEach((item) => {
        item.classList.remove('collection-list__title--selected')
      })
      titleItems[index].classList.add('collection-list__title--selected')
      
      const selectedCard = section.querySelector('[data-selected]')
      const isAlreadySelected = card === selectedCard

      if (!isAlreadySelected) {
        e.preventDefault()
        swapCards(card)
      }
    })
  })
})
